import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const CalibrationRedirect: React.FC = () => {
  const { jobNumber, woDetailGlobalId } = useParams<{
    jobNumber: string;
    woDetailGlobalId?: string;
  }>();

  const search = woDetailGlobalId
    ? `?instrument=${encodeURIComponent(woDetailGlobalId)}`
    : '';

  return <Navigate to={`/work/${jobNumber}/calibration${search}`} replace />;
};

export default CalibrationRedirect;
